import React from 'react';
import { createRoot } from 'react-dom/client';

// Shield theme styles (use the main shield.css which includes reset and fonts)
import '@usb-shield/themes/dist/styles/shield.css';

// Peer dependency styles
import '@usb-shield/react-icons/dist/library/styles/index.css';
import '@usb-shield/react-button/dist/library/styles/index.css';

// Table component styles
import '@usb-shield/react-table/dist/library/styles/index.css';

import App from './App';
import { store } from './shared/store';
import { Provider } from 'react-redux';

const root = createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <App />
    </Provider>
  </React.StrictMode>
);
